import React, { useState, useEffect, useCallback } from "react";
import UserContext from "./UserContext";
import { getRequest } from "../utils/axiosgetrequest";
import { useNavigate } from "react-router-dom";

const UserContextProvider = ({ children }) => {
  const [userDetail, setUserDetail] = useState(null);
  const [updateVariable, setUpdateVariable] = useState(true);
  const navigate = useNavigate();

  // Toggle the variable to trigger re-fetch
  const updateVariableHandler = () => {
    setUpdateVariable((prev) => !prev);
  };

  // Fetch user details
  const getUserDetails = useCallback(async () => {
    const token = localStorage.getItem("access_token");
    const endpoint = `memberships/get_member_details`; // Updated endpoint

    if (token && localStorage.getItem("flag") === "member") {
      try {
        const res = await getRequest(endpoint, token);
        setUserDetail(res.data);
      } catch (error) {
        console.error("Error fetching user details:", error);
        // Optionally handle specific errors (e.g., unauthorized)
        if (error.response?.status === 401) {
          // Handle unauthorized access (e.g., redirect to login)
          localStorage.removeItem("access_token");
          localStorage.removeItem("flag");
          navigate("/login");
        }
      }
    }
  }, [navigate]);

  useEffect(() => {
    getUserDetails();
  }, [getUserDetails, updateVariable]);

  return (
    <UserContext.Provider
      value={{ userDetail, updateVariableHandler, getUserDetails }}
    >
      {children}
    </UserContext.Provider>
  );
};

export default UserContextProvider;
